import { motion } from "framer-motion";
import { BusinessAnalytics } from "@/components/businesses/BusinessAnalytics";
import { BusinessMenuNav } from "@/components/businesses/BusinessMenuNav";
import { BusinessesExplorer } from "@/components/businesses/BusinessesExplorer";
import { PageHeader } from "@/components/ui/PageHeader";
import { ExplorerSkeleton } from "@/components/ui/PageSkeleton";
import { deriveConnectedServiceStatus } from "@/lib/business-analytics";
import { useBusinessPlatformData } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function BusinessesPage() {
  const { data, isLoading, error } = useBusinessPlatformData();

  const pendingCount =
    data?.services.filter((service) => deriveConnectedServiceStatus(service) === "pending").length ??
    0;

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="space-y-6"
    >
      <PageHeader
        title="Businesses"
        description="Oversee every business in the Shft ecosystem, review Connected Services applications, and inspect customers and pricing."
        showGreeting={false}
      />

      <BusinessMenuNav pendingCount={pendingCount} />

      {isLoading ? (
        <ExplorerSkeleton title="Businesses" />
      ) : error ? (
        <p className="text-sm text-red-600">Failed to load businesses. Please try again.</p>
      ) : data ? (
        <>
          <BusinessAnalytics
            businesses={data.businesses}
            services={data.services}
            customers={data.customers}
          />
          <BusinessesExplorer entries={data.entries} />
        </>
      ) : null}
    </motion.div>
  );
}
